export default __webpack_public_path__ + "static/img/face_covered_pic.3555d19.svg";